import React , { useEffect , useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody } from "reactstrap";
import { set_rename_modal, setnew_element } from "../../../slices/dashboard/reducer";
import { store } from "../../..";

const RenameModal = ({ }) => {
    const dispatch = useDispatch();
    const [title, settitle] = useState("")

    const { rename_modal_status , title_id  , new_element} = useSelector(
    (state) => state.Dashboard
  );
   
  useEffect(() => {

    if(title_id && rename_modal_status ){
        let parent = document.querySelector(`[gs-id="${title_id}"]`).firstElementChild.firstElementChild
        console.log(parent.firstElementChild.innerHTML , "Title Value ")
        settitle(parent.firstElementChild.innerHTML)
    }
      
  }, [rename_modal_status])


  const onCloseClick=()=>{
      console.log("Callinf Close Renmae ")
      store.dispatch(set_rename_modal(!rename_modal_status))
      settitle("")
  }


  const onClickSave =()=>{
      let parent = document.querySelector(`[gs-id="${title_id}"]`).firstElementChild.firstElementChild
      parent.firstElementChild.innerHTML=title
       
      const updated_title = JSON.parse(JSON.stringify(new_element)).map((ele)=>{
             if(ele.id == title_id){
               ele.title = title
              return ele
             }
             return ele
      })

      dispatch(setnew_element(updated_title))

       onCloseClick()
  }
  


  return (
    <Modal isOpen={rename_modal_status} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">

          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <h4>Rename Element</h4>
            <div className="rename-input_wrapper">
              <input value={title} onChange={(e)=>{
                  settitle(e.target.value)
              }}  type="text" className="form-control" placeholder="New Name" />
            </div>
          </div>
        </div>

        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            onClick={onCloseClick}                      >
            Cancel
          </button>
          <button
            type="button"
            className="btn w-sm btn-secondary"    
            onClick={onClickSave}        
          >
            save
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default RenameModal;
